export const MinTradingViewDate: string = '2003-01-01'
